import { makeStyles } from "@mui/styles";

const mailStyle = makeStyles((theme) => ({
  mailBox: {
    backgroundColor: "#00796b",
    color: "#fff !important",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down(780)]: {
      padding: "12px 0px !important",
    },
  },
  gridContainer: {
    justifyContent: "space-between",
    [theme.breakpoints.down(780)]: {
      justifyContent: "center",
    },
  },
  socialIcons: {
    fontSize: "20px !important",
    color: "#fff",
    marginRight: "3px !important",
    opacity: "0.8",
    "&:hover": {
      opacity: "1",
    },
  },
  displayNone: {
    [theme.breakpoints.down(780)]: {
      display: "none",
    },
  },
}));

export default mailStyle;
